import { AppState } from 'Store'

export const partnerSelector = {
	getPartnerProducts: (state: AppState) => state.pp.partner.products.entries,
	getPartnerFull: (state: AppState) => state.pp.partner.partnerFull,
	getEntitySelector: (state: AppState) => state.page.entity,
	getUserPhoneSelector: (state: AppState) => state.auth.phone || '',
	getUserIsSignerSelector: (state: AppState) => state.auth.signer || null,
	getDocumentTypesDictsSelector: (state) =>
		state?.modules?.dicts?.all?.partner_contract_document_types ?? [],
}
